import { useState } from "react";
import { useSelector } from "react-redux";

import { Page, Steps } from "../../helbest";
import Addresses from "../components/Delivery/NewAddresses/Addresses";
import {
  useCheckoutDeliveryMethodUpdateMutation,
  useCheckoutShippingAddressUpdateMutation,
} from "../../saleor/api";
import { showAllErrors } from "../../base/utils";
import styles from "../components/Delivery/Delivery.module.css";
import { useTranslation } from "react-i18next";
import { Button, Spin } from "antd";
import HeaderBack from "../../helbest/HeaderBack/HeaderBack";
import { useLangNavigate } from "../../hooks/useLangNavigate";

const Delivery = (props) => {
  const login = useSelector((store) => store.Login);
  const navigate = useLangNavigate();
  const [shippingOptions, setShippingOptions] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [optionLoading, setOptionLoading] = useState(false);
  const [selectedShippingOption, setSelectedShippingOption] = useState(null);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const [checkoutDeliveryMethodUpdateMutation] =
    useCheckoutDeliveryMethodUpdateMutation({
      variables: {
        id: login.checkoutId,
        deliveryMethodId: selectedShippingOption,
      },
      onCompleted(response) {
        setLoading(false);
        if (!response.checkoutDeliveryMethodUpdate.errors.length) {
          navigate("/payment/");
        } else {
          showAllErrors(response.checkoutDeliveryMethodUpdate.errors);
        }
      },
    });

  const [checkoutShippingAddressUpdate] =
    useCheckoutShippingAddressUpdateMutation({
      onCompleted: (response) => {
        setOptionLoading(false);
        if (!response.checkoutShippingAddressUpdate.errors.length) {
          setShippingOptions(
            response.checkoutShippingAddressUpdate.checkout.shippingMethods
          );
          setSelectedShippingOption(null);
        } else {
          showAllErrors(response.checkoutShippingAddressUpdate.errors);
        }
      },
    });

  const onSubmit = (addressItem) => {
    setOptionLoading(true);
    checkoutShippingAddressUpdate({
      variables: {
        id: login.checkoutId,
        shippingAddress: {
          streetAddress1: addressItem.address,
          streetAddress2: addressItem.details,
          country: addressItem.country,
          countryArea: addressItem.region,
          companyName: addressItem.company_name,
          city: addressItem.city,
          postalCode: addressItem.postal_code,
          phone: addressItem.phone,
          firstName: addressItem.firstName,
          lastName: addressItem.lastName,
          metadata: addressItem.location
            ? [
                {
                  key: "location",
                  value: `${addressItem.location.lng}, ${addressItem.location.lat}`,
                },
              ]
            : [],
        },
        validationRules: { checkRequiredFields: false },
      },
    });
  };

  if (!login.is_login) {
    navigate("/login/");
  }

  return (
    <Page
      className="page-delivery"
      showFooter
      customHeader={<HeaderBack title={t("cart.shipping")} url={"/cart/"} />}
      headerFix
      extra_header={<Steps open={true} step={2} hasShadow />}
      noFooter
    >
      <div className={styles.Delivery}>
        <Addresses
          selectedAddress={selectedAddress}
          setSelectedAddress={setSelectedAddress}
          selectedShippingOption={selectedShippingOption}
          setSelectedShippingOption={setSelectedShippingOption}
          match={props.match}
          shippingMethods={shippingOptions || []}
          onSubmit={onSubmit}
          optionLoading={optionLoading}
        />
      </div>
      <div className="page-fixed-footer-container">
        <Button
          size="large"
          type="primary"
          style={{
            width: "100%",
          }}
          loading={loading}
          disabled={
            !selectedAddress || !selectedShippingOption || optionLoading
          }
          onClick={() => {
            setLoading(true);
            checkoutDeliveryMethodUpdateMutation();
            // checkoutShippingMethodUpdateMutation();
          }}
        >
          {t("common.next")}
        </Button>
      </div>
    </Page>
  );
};

export default Delivery;
